function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiskovLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "rgb(227, 224, 224)"
    },
    cx: 240.788,
    cy: 250.442,
    rx: 164.268,
    ry: 164.268
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.67 366.873 L 98.67 144.885 L 162.095 144.885 L 162.095 335.16 L 288.945 335.16 L 288.945 366.873 Z",
    style: {
      fill: "rgb(107, 142, 35)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 366.291 284.523 L 366.291 238.898 L 411.916 238.898 L 411.916 284.523 Z M 343.479 375.773 L 343.479 352.96 L 366.291 352.96 L 366.291 307.335 L 411.916 307.335 L 411.916 352.96 L 389.104 352.96 L 389.104 375.773 Z",
    style: {
      fill: "rgb(107, 142, 35)",
      whiteSpace: "pre"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiskovLogo);
export default __webpack_public_path__ + "static/media/Liskov_logo.d033429a.svg";
export { ForwardRef as ReactComponent };